export default {
  fast    : '.1s',
  default : '.2s',
  long    : '.6s',
};
